var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(24.25 -5.439) rotate(90)"},React.createElement("g",{"transform":"translate(0 8.442)"},[React.createElement("path",{"d":"M16.5,18.5l-5,5-5-5","transform":"translate(0 -8.442)","fill":"none","stroke":"#97a6aa","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":0}),React.createElement("line",{"y1":"14.558","transform":"translate(11.5 0.5)","strokeWidth":"1.5","stroke":"#97a6aa","strokeLinecap":"round","strokeLinejoin":"round","fill":"none","key":1})])));
}

ArrowLeft.defaultProps = {"width":"16.058","height":"12.121","viewBox":"0 0 16.058 12.121"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
